"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.SEO = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _dec, _class;

var SEO = (_dec = (0, _mobxReact.inject)("siteConfig"), _dec(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(SEO, _Component);

  function SEO(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = SEO.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        postNode = _this$props.postNode,
        postSEO = _this$props.postSEO,
        seoMetadata = _this$props.seoMetadata,
        siteConfig = _this$props.siteConfig,
        Head = _this$props.Head;
    var description;
    var robots;

    if (seoMetadata) {
      description = seoMetadata.description;

      if (seoMetadata.robots) {
        robots = Object.keys(seoMetadata.robots).filter(function (key) {
          return seoMetadata.robots[key] === true;
        }).join(",");
      }
    }

    var title;
    var siteName = siteConfig.siteTitle;
    var canonicalUrl;
    var manifestUrl;
    var favicon16Path;
    var favicon32Path;
    var maskIconHref;
    var maskIconColor; // let image;

    if (postSEO) {
      var postMeta = postNode.frontmatter;
      title = postMeta.title;
      description = postMeta.description ? postMeta.description : postNode.excerpt; // image = postMeta.cover ? postMeta.cover : config.siteLogo;
    } else {
      if (seoMetadata && seoMetadata.title) {
        title = seoMetadata.title;
      } else if (this.props.title) {
        title = this.props.title;
      } // if (this.props.urlPath) {
      // }
      // image = config.siteLogo;

    }

    var realPrefix = siteConfig.pathPrefix === "/" ? "" : siteConfig.pathPrefix;
    var realUrlPath = this.props.urlPath === "/" ? "" : this.props.urlPath;

    if (this.props.urlPath) {
      canonicalUrl = "" + siteConfig.siteUrl + realPrefix + realUrlPath;
    }

    if (siteConfig.manifestPath) {
      manifestUrl = "" + siteConfig.manifestPath;
    }

    if (siteConfig.favicon16Path) {
      favicon16Path = siteConfig.favicon16Path;
    }

    if (siteConfig.favicon32Path) {
      favicon32Path = siteConfig.favicon32Path;
    }

    if (siteConfig.maskIcon) {
      ;

      var _siteConfig$maskIcon$ = siteConfig.maskIcon.split(",");

      var _siteConfig$maskIcon$2 = (0, _slicedToArray2.default)(_siteConfig$maskIcon$, 2);

      maskIconHref = _siteConfig$maskIcon$2[0];
      maskIconColor = _siteConfig$maskIcon$2[1];
    } // TODO Canonical may need to take into account parameters etc and these don't want trailing /


    if (canonicalUrl && !canonicalUrl.endsWith("/")) {
      canonicalUrl += "/";
    } // image = config.siteUrl + realPrefix + image;


    var blogURL = siteConfig.siteUrl + siteConfig.pathPrefix;
    var schemaOrgJSONLD = [{
      "@context": "http://schema.org",
      "@type": "WebSite",
      url: blogURL,
      name: siteName,
      alternateName: siteConfig.siteTitleAlt ? siteConfig.siteTitleAlt : ""
    }];

    if (postSEO) {
      schemaOrgJSONLD.push([{
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [{
          "@type": "ListItem",
          position: 1,
          item: {
            "@id": canonicalUrl,
            name: title // image,

          }
        }]
      }, {
        "@context": "http://schema.org",
        "@type": "BlogPosting",
        url: blogURL,
        name: title,
        alternateName: siteConfig.siteTitleAlt ? siteConfig.siteTitleAlt : "",
        headline: title,
        image: {
          "@type": "ImageObject" // url: image,

        },
        description: description
      }]);
    } // no Site Name postFix for homepage


    var titleLabel = realUrlPath !== "" ? title + " | " + siteConfig.siteTitle : title;
    return _react.default.createElement(Head, null, _react.default.createElement("title", null, titleLabel), robots && _react.default.createElement("meta", {
      name: "robots",
      content: robots
    }), description && _react.default.createElement("meta", {
      name: "description",
      content: description
    }), canonicalUrl && _react.default.createElement("link", {
      rel: "canonical",
      href: canonicalUrl
    }), manifestUrl && _react.default.createElement("link", {
      rel: "manifest",
      href: manifestUrl
    }), favicon16Path && _react.default.createElement("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: favicon16Path
    }), favicon32Path && _react.default.createElement("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: favicon32Path
    }), siteConfig.appleTouchIcon && _react.default.createElement("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: siteConfig.appleTouchIcon
    }), siteConfig.maskIcon && _react.default.createElement("link", {
      rel: "mask-icon",
      href: maskIconHref,
      color: maskIconColor
    }), siteConfig.tileColor && _react.default.createElement("meta", {
      name: "msapplication-TileColor",
      content: siteConfig.tileColor
    }), _react.default.createElement("meta", {
      name: "theme-color",
      content: siteConfig.themeColor
    }), _react.default.createElement("script", {
      type: "application/ld+json"
    }, JSON.stringify(schemaOrgJSONLD)), canonicalUrl && _react.default.createElement("meta", {
      property: "og:url",
      content: canonicalUrl
    }), postSEO && _react.default.createElement("meta", {
      property: "og:type",
      content: "article"
    }), title && _react.default.createElement("meta", {
      property: "og:title",
      content: title
    }), description && _react.default.createElement("meta", {
      property: "og:description",
      content: description
    }), siteConfig.siteFBAppID && _react.default.createElement("meta", {
      property: "fb:app_id",
      content: siteConfig.siteFBAppID
    }), _react.default.createElement("meta", {
      name: "twitter:card",
      content: "summary"
    }), siteConfig.userTwitter && _react.default.createElement("meta", {
      name: "twitter:site",
      content: siteConfig.userTwitter
    }), title && _react.default.createElement("meta", {
      name: "twitter:title",
      content: title
    }), description && _react.default.createElement("meta", {
      name: "twitter:description",
      content: description
    }));
  };

  return SEO;
}(_react.Component)) || _class);
exports.SEO = SEO;